<template>
    <div class="learn-box">
        <div class="statistics-box">
            <div class="style1">
                <div class="title">课堂活动完成情况</div>
                <div class="text">{{ num }}/{{ allnum }}</div>
            </div>
            <div class="style2">
                <div class="title">学习时长</div>
                <div class="text">{{ info.readingTime }}分</div>
            </div>
        </div>
        <div class="chart-box">
            <div class="model-title">课堂活动统计</div>
            <div class="model-body">
                <div class="left-card">
                    <div id="myChart" style="width: 340px;height: 420px"></div>
                </div>
                <div class="right-card">
                    <div class="top-select-bar">
                        <div>
                            <el-dropdown @command="selectItem">
                                <span class="el-dropdown-link" style="cursor: pointer;">
                                    {{ curType.name }}<i class="el-icon-arrow-down el-icon--right"></i>
                                </span>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item :command="item" v-for="(item,index) in typeList" :key="index">
                                        {{ item.name }}
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                        <div style="cursor: pointer;">
                            <div class="deta-select">
                                {{ dateValStr || '时间筛选' }}<i class="el-icon-arrow-down el-icon--right"></i>
                            </div>
                            <el-date-picker v-model="dateVal" type="daterange" range-separator="" start-placeholder=""
                                end-placeholder="" prefix-icon="" size="mini" @change="dateChange">
                            </el-date-picker>
                        </div>
                    </div>
                    <div class="steps-box">
                        <div class="steps-body">
                            <div class="steps-item" v-for="(item, index) in activeList" :key="index">
                                <div class="date">
                                    <span>{{ parseTime(item.finishTime, '{m}月{d}日 {h}:{i}') }}</span>
                                    <span>发起人:  {{ item.createBy }}</span>
                                </div>
                                <div class="text">
                                    <span>参与</span> {{ item.title }}
                                </div>
                            </div>
                        </div>

                        <noData v-if="activeList.length == 0"></noData>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import * as echarts from 'echarts';
import { GetStatistics, GetActiveList,GetReadStatistics } from '@/api/user/course'
import noData from "@/components/noData.vue";

export default {
    name: 'LearnSituation',
    components: { noData },
    props: {
        courseData: {
            type: Object,
            default: {}
        },
        goodInfo:{
            type:Object,
            default:{}
        }
    },
    data() {
        return {
            option: {
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    orient: 'horizontal',
                    bottom: '10%',
                },
                series: [
                    {
                        name: '',
                        type: 'pie',
                        radius: '50%',
                        data: [
                            { value: 0, name: '讨论' },
                            { value: 0, name: '问卷' },
                            { value: 0, name: '随堂练习' },
                        ],
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }
                ],
            },
            num: 0,
            allnum: 0,

            activeList: [],
            typeList: [ //0 问卷 1随堂测验 2讨论
                {
                    name: '全部',
                    id: ''
                },
                {
                    name: '问卷',
                    id: 0
                },
                {
                    name: '讨论',
                    id: 2
                },
                {
                    name: '随堂练习',
                    id: 1
                }
            ],
            curType: {
                name: '类型筛选',
                id: ''
            },
            dateVal: '',
            dateValStr: '',
            beginTime: '',
            endTime: '',
            info:{},
        }
    },
    watch: {
        courseData: {
            handler(newval) {
                if (newval.classId) {
                    this.getStatisticsInfo()
                    this.getlist()
                    setTimeout(() => {
                    this.getRead()
                    }, 2000);

                }
            }
        }
    },
    mounted() {
        this.getStatisticsInfo()
        this.getlist()
        setTimeout(() => {
        this.getRead()
        }, 2000);
    },
    methods: {

        //获取统计数据
        getStatisticsInfo() {
            GetStatistics({
                classId: this.courseData.classId,
            }).then(res => {
               
                this.allnum = res.data.classroomTestCount + res.data.discussCount + res.data.questionnaireCount
                this.num = res.data.userClassroomTestCount + res.data.userDiscussCount + res.data.userQuestionnaireCount

                setTimeout(() => {
                    this.option.series[0].data[0].value = res.data.userDiscussCount
                    this.option.series[0].data[1].value = res.data.userQuestionnaireCount
                    this.option.series[0].data[2].value = res.data.userClassroomTestCount

                    var chartDom = document.getElementById('myChart');
                    var myChart = echarts.init(chartDom);

                    myChart.setOption(this.option);

                }, 1000);
            })
        },

        //获取学习时长
        getRead(){
            GetReadStatistics({
                fileId:this.goodInfo.filesId,
                goodsId:this.goodInfo.goodsId
            }).then(pop=>{
                this.info = pop.data
                
            })
        },

        //获取活动
        getlist() {
            GetActiveList({
                classId: this.courseData.classId,
                type: this.curType.id,
                beginTime: this.beginTime,
                endTime: this.endTime,
                isJoin: '1'
            }).then(res => {
                this.activeList = res.rows
            })
        },

        selectItem(e) {
            console.log(e);
            this.curType = e
            this.getlist()
        },

        dateChange(e) {
            this.beginTime = this.parseTime(e[0], '{y}-{m}-{d}')
            this.endTime = this.parseTime(e[1], '{y}-{m}-{d}')
            console.log(this.beginTime);
            this.dateValStr = this.beginTime + '-' + this.endTime
            this.getlist()
        }
    }
}
</script>
<style scoped lang='scss'>
::v-deep .el-range-editor--mini .el-range-input{
    cursor: pointer;
}
.learn-box {
    padding: 0 26px;


    .statistics-box {
        display: flex;
        align-items: center;
        justify-content: space-between;

        >div {
            width: 472px;
            height: 116px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            padding-left: 30px;

            .title {
                font-family: PingFang SC, PingFang SC;
                font-weight: bold;
                font-size: 18px;
                color: #333333;
            }

            .text {
                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                font-size: 16px;
                color: #666666;
                margin-top: 17px;
            }
        }

        .style1 {
            background-image: url('../../../../assets/images/style_bg1.png');
            background-size: 100% 100%;
            background-repeat: no-repeat;
        }

        .style2 {
            background-image: url('../../../../assets/images/style_bg2.png');
            background-size: 100% 100%;
            background-repeat: no-repeat;
        }

    }

    .chart-box {
        margin-top: 30px;

        .model-title {
            font-family: PingFang SC, PingFang SC;
            font-weight: bold;
            font-size: 16px;
            color: #333333;
        }

        .model-body {
            margin-top: 14px;
            display: flex;
            align-items: flex-start;
            justify-content: space-between;
            padding-bottom: 1px;

            .left-card {
                width: 343px;
                height: 420px;
                background: #FFFFFF;
                box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.2);
                border-radius: 10px 10px 10px 10px;
            }

            .right-card {
                width: calc(100% - 363px);
                height: 420px;
                background: #FFFFFF;
                box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.2);
                border-radius: 10px 10px 10px 10px;

                .top-select-bar {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 18px 30px;
                    border-bottom: 1px solid #F2F2F2;

                    .deta-select {
                        height: 24px;
                        width: 200px;
                        background: #FFFFFF;
                        display: flex;
                        align-items: center;
                        justify-content: flex-end;
                        position: absolute;
                        right: 50px;
                        z-index: 9;
                        text-align: right;
                        pointer-events: none;
                        color: #606266;
                        font-size: 14px;

                    }

                    .el-input__inner {
                        height: 24px !important;
                        width: 100px !important;
                    }
                }

                .steps-box {
                    padding: 20px;
                    box-sizing: border-box;
                    max-height: calc(100% - 50px);
                    overflow: auto;

                    .steps-body {
                        position: relative;

                        &::before {
                            content: '';
                            width: 1px;
                            height: 100%;
                            background: #2E9ADB;
                            position: absolute;
                            left: 0;
                            top: 8px;
                        }

                        .steps-item {
                            margin-bottom: 11px;
                            padding-left: 15px;
                            position: relative;

                            &::before {
                                content: '';
                                width: 8px;
                                height: 8px;
                                background: #FFFFFF;
                                border-radius: 0px 0px 0px 0px;
                                border: 1px solid #2E9ADB;
                                position: absolute;
                                left: -4px;
                                top: 5px;
                                border-radius: 50%;
                            }

                            .date {
                                font-family: PingFang SC, PingFang SC;
                                font-weight: 500;
                                font-size: 14px;
                                color: #999999;

                                span {
                                    margin-right: 24px;
                                }
                            }

                            .text {
                                font-family: PingFang SC, PingFang SC;
                                font-weight: 500;
                                font-size: 16px;
                                color: #333333;
                                margin-top: 16px;
                                margin-bottom: 24px;

                                span {
                                    margin-right: 10px;
                                }
                            }
                        }
                    }
                }
            }
        }

    }
}
</style>